import GamePlays from "../data/gameplay.json";
export default GamePlays;
